import { TqcAnalItemResultDto } from "src/dtos/tqcAnalItemResult/tqcAnalItemResultDto";

/**
 * 액 분석 일지 화면 DTO
 * 분석 실적 도메인 DTO에 마스터 조회값과 화면 상태를 확장한다.
 */
export interface TQC2080_R01Dto extends TqcAnalItemResultDto {
	// 마스터 필드 (읽기 전용)
	processNm: string;
	testItem: string;
	stdRange: string;
	centerVal: number;
	talkVol: number;

	shortage: number; // 프론트 계산 (analysisVal - centerVal)

	// UI 상태
	inserted: boolean;
	isModified: boolean;
}

export const defaultTQC2080_R01Dto: TQC2080_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	itemNo: 0,
	processNm: "",
	testItem: "",
	stdRange: "",
	centerVal: 0,
	talkVol: 0,

	analysisDt: "",
	analysisVal: 0,
	shortage: 0,
	remark: "",

	supplyQty: 0,
	secondAnal: 0,
	fieldConfirm: "",

	insertDt: new Date(),
	insertUser: "",
	insertForm: "",
	updateDt: new Date(),
	updateUser: "",
	updateForm: "",

	inserted: false,
	isModified: false,
};
